module.exports = __webpack_public_path__ + "img/reward.af299682.svg";